import { render, staticRenderFns } from "./detail-testPaperUs.vue?vue&type=template&id=46d58939&scoped=true&"
import script from "./detail-testPaperUs.vue?vue&type=script&lang=ts&"
export * from "./detail-testPaperUs.vue?vue&type=script&lang=ts&"
import style0 from "./detail-testPaperUs.vue?vue&type=style&index=0&id=46d58939&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46d58939",
  null
  
)

export default component.exports